<template>
  <v-dialog
      :model-value="showModal"
      @update:model-value="closeDialog()"
      max-width="500px"
  >
    <v-card>
      <v-card-text>
        <v-alert
            type="error"
            :icon="mdiAlert"
            >{{ $t('global.info-modal.label.db-warning') }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="text" @click="closeDialog">{{ $t("global.btn.cancel")}}</v-btn>
        <v-btn :disabled="disabled" color="red-darken-4" variant="text" @click="replaceDbConfirm">{{ $t('global.info-modal.label.replace-db') }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue';
import {
  mdiAlert
} from '@mdi/js';

const props = defineProps({
  show: {
    type: Boolean,
    required: true
  },
  disabled: {
    type: Boolean,
    required: false
  }
});

const emit = defineEmits(['closeDialog', 'replaceDb']);

function closeDialog() {
  emit('closeDialog');
}

function replaceDbConfirm() {
  emit('replaceDb');
}

const showModal = computed(() =>
    props.show
);

</script>
